<template>
    <DCard padding>
        <DRow
            align-horizontal="start"
            align-vertical="end"
        >
            <DCol lg="1">
                <DInput
                    id="transfer-id"
                    v-model="filtersList.transferId"
                    :label="__('contracts.transfers.table.transfer_id')"
                    type="number"
                    @keydown.enter.exact.prevent="filter(transfers.current_page, filters)"
                />
            </DCol>
            <DCol lg="2">
                <DInput
                    id="customer-id"
                    v-model="filtersList.customerId"
                    :label="__('contracts.transfers.filters.customer_id')"
                    type="number"
                    @keydown.enter.exact.prevent="filter(transfers.current_page, filters)"
                />
            </DCol>
            <DCol lg="2">
                <DInput
                    id="email"
                    v-model="filtersList.email"
                    :label="__('contracts.transfers.filters.email')"
                    type="email"
                    @keydown.enter.exact.prevent="filter(transfers.current_page, filters)"
                />
            </DCol>
            <DCol lg="2">
                <DInput
                    id="contract-id"
                    v-model="filtersList.contractId"
                    :label="__('contracts.transfers.filters.contract_id')"
                    type="number"
                    @keydown.enter.exact.prevent="filter(transfers.current_page, filters)"
                />
            </DCol>
            <DCol lg="2">
                <label class="form-group">{{ __('contracts.transfers.table.status') }}</label>
                <DMultiSelect
                    id="statuses"
                    :options="statusOptions"
                    selection-type="text"
                    :selected="selectedStatusList"
                    @update="onStatusesFilterChange"
                />
            </DCol>
            <DCol
                lg="3"
                class="d-flex gap-2"
            >
                <DButton
                    id="filter-apply"
                    :label="__('messages.actions.filter')"
                    @click="filter(transfers.current_page, filters)"
                />
                <DButton
                    id="filter-reset"
                    icon="filter-off"
                    :label="__('messages.actions.reset_filter')"
                    @click="resetFilters"
                />
            </DCol>
        </DRow>
        <DRow class="mt-3">
            <DCol lg="12">
                <DTable
                    :fields="fields"
                    :items="transfers.items"
                >
                    <template #customer_name="{item}">
                        <td>
                            {{ item.customer_name && item.customer_name }} / {{ item.company_name && item.company_name }}
                            <Link :href="$route('customers.customers.show', {customer: item.customer_id})">
                                ({{ item.customer_id }})
                            </Link>
                        </td>
                    </template>
                    <template #list_of_contracts="{item}">
                        <td>
                            <div
                                v-for="(contract, key) in item.list_of_contracts"
                                :key="key"
                            >
                                <div :style="`padding-left: ${contract.level * 8}px`">
                                    {{ contract.name }}
                                    <Link
                                        :href="$route('customers.customers.contracts.index', {customer: item.customer_id, contract: contract.id })"
                                    >
                                        (#{{ contract.id }})
                                    </Link>
                                </div>
                            </div>
                        </td>
                    </template>
                    <template #date_started_ended="{item}">
                        <td>
                            {{ setDateFormat(item.start_date) }}{{ item.end_date ? ` / ${setDateFormat(item.end_date)}` : '' }}
                        </td>
                    </template>
                    <template #status="{item}">
                        <td>
                            {{ __('contracts.transfers.status.' + item.status) }}
                        </td>
                    </template>
                    <template #action="{item}">
                        <td>
                            <DButton
                                :label="__('contracts.transfers.table.cancel_transfer')"
                                color="danger"
                                :disabled="item.status !== 'open' ? true:false"
                                @click="cancelTransfer(item)"
                            />
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="transfers.last_page > 1"
                    :active-page="transfers.current_page"
                    :pages="transfers.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
    </DCard>
    <DModal
        v-model:show="showConfirmationModal"
        :title="__('contracts.transfers.delete_modal.title')"
        :message="__('contracts.transfers.delete_modal.body')"
        is-confirm
        is-error
        @close="showConfirmationModal = false"
        @confirm="cancelCallBack"
    />
</template>

<script>
export default {
    name: 'TransfersIndex',
    props: {
        transfers: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => { return {} }
        },
        statuses: {
            type: Array,
            default: () => { return [] }
        },
        selectedStatuses: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'transfer_id', label: this.__('contracts.transfers.table.transfer_id') },
                { key: 'customer_name', label: this.__('contracts.transfers.table.customer_name') },
                { key: 'customer_new', label: this.__('contracts.transfers.table.customer_new') },
                { key: 'list_of_contracts', label: this.__('contracts.transfers.table.list_of_contracts') },
                { key: 'date_started_ended', label: this.__('contracts.transfers.table.date_started_ended') },
                { key: 'status', label: this.__('contracts.transfers.table.status') },
                { key: 'action', label: this.__('contracts.transfers.table.action') }
            ],
            showConfirmationModal: false,
            selectedStatusList: this.selectedStatuses,
            filtersList: this.filters,
            cancelCallBack: () => { return {} }
        }
    },
    computed: {
        statusOptions () {
            return this.statuses.map((status) => {
                return {
                    value: status,
                    text: this.__('contracts.transfers.status.' + status),
                    selected: this.selectedStatusList.includes(status)
                }
            })
        }
    },
    methods: {
        onStatusesFilterChange (selectedStatuses) {
            this.filtersList.selectedStatuses = selectedStatuses
        },
        cancelTransfer (item) {
            this.cancelCallBack = () => {
                this.$inertia.patch(
                    this.$route('contracts.transfers.cancel', {
                        transfer: item.transfer_id
                    }),
                    {
                        preserveScroll: true
                    }
                )
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        changePage (page) {
            const query = {}
            if (page > 1) {
                query.page = page
            }
            this.filter(page, this.filter)
            this.$inertia.get(this.$route('contracts.transfers'), query)
        },
        filter (page, filtersList) {
            const queryParameters = Object.fromEntries(Object.entries(this.filtersList).filter(([_, v]) => v))
            if (page > 1) {
                queryParameters.page = page
            }
            const routeParameters = {
                save_filters: true
            }

            this.$inertia.get(this.$route('contracts.transfers', routeParameters), queryParameters)
        },
        resetFilters () {
            const routeParameters = {
                save_filters: true,
                default_filters: true
            }

            this.$inertia.get(this.$route('contracts.transfers', routeParameters))
        },
        closeModal () {
            this.showConfirmationModal = false
            this.deleteCallBack = () => { return {} }
        }
    }
}
</script>
